import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Field } from 'redux-form/immutable';
import Grid from '@material-ui/core/Grid';

import FormTextField from 'retired/FormTextField';
import { PasswordRequirements } from 'components/PasswordRequirements';
import { getUserInputs, validatePassword } from 'utils/password';

const getStringValueFromImmutable = (obj) => ('toJS' in (obj || {}) ? obj.toJS() : obj);

const FormPasswordField = ({ names, firstFieldProps, secondFieldProps, userInputs, ...rest }) => {
  const passwordValue = rest[names[0]].input.value;

  const [allUserInputs, setAllUserInputs] = useState({
    currentUser: getStringValueFromImmutable(userInputs?.currentUser),
    formValues: {},
  });

  return (
    <Grid container>
      <Grid item xs={12}>
        <Field
          component={FormTextField}
          fullWidth
          type="password"
          validate={(value = '', formValues = {}) => {
            setAllUserInputs({
              currentUser: getStringValueFromImmutable(userInputs?.currentUser),
              formValues: getStringValueFromImmutable(formValues),
            });
            return !!validatePassword(value, getUserInputs(allUserInputs));
          }}
          {...firstFieldProps}
        />
        {passwordValue?.length ? (
          <PasswordRequirements
            password={passwordValue}
            userInputs={getUserInputs(allUserInputs)}
          />
        ) : null}
      </Grid>

      <Grid item xs={12}>
        <Field
          component={FormTextField}
          fullWidth
          type="password"
          {...secondFieldProps}
          validate={(value = '') => (value === passwordValue ? undefined : 'Does not match')}
        />
      </Grid>
    </Grid>
  );
};

FormPasswordField.propTypes = {
  names: PropTypes.array,
  error: PropTypes.bool,
  userInputs: PropTypes.object,
  firstFieldProps: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    label: PropTypes.string,
    hintText: PropTypes.string,
    required: PropTypes.bool,
  }),
  secondFieldProps: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    label: PropTypes.string,
    hintText: PropTypes.string,
    required: PropTypes.bool,
  }),
};

export default FormPasswordField;
